import React, { useState } from "react";
import { Mail, Check } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";
import { toast } from "sonner";

/**
 * Small email-capture form for the public footer.
 * Posts to /api/newsletter/subscribe.
 */
export default function NewsletterForm() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setLoading(true);
        try {
            const r = await subscribeNewsletter(email.trim(), "footer");
            if (r?.already_subscribed) {
                toast("You're already subscribed", { description: "You'll keep receiving our updates." });
            } else {
                toast.success("Subscribed — welcome!");
            }
            setDone(true);
            setEmail("");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Subscribe failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={submit} className="w-full max-w-md" data-testid="newsletter-form">
            <div className="font-sub text-[10px] uppercase tracking-[0.24em] text-black/50 mb-2 flex items-center gap-2">
                <Mail className="w-3.5 h-3.5" />
                Get the daily market brief
            </div>
            {done ? (
                <div className="flex items-center gap-2 border border-[#22E578] bg-[#22E578]/10 text-[#0FA95A] rounded-sm px-3 py-2.5 font-sub text-sm" data-testid="newsletter-done">
                    <Check className="w-4 h-4" /> Thanks &mdash; you&apos;re on the list.
                </div>
            ) : (
                <div className="flex items-stretch gap-2">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@example.com"
                        required
                        className="flex-1 border border-black/15 rounded-sm py-2.5 px-3 font-body text-sm bg-white focus:border-[#22E578] focus:ring-2 focus:ring-[#22E578]/40 outline-none"
                        data-testid="newsletter-email"
                    />
                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-[#22E578] text-black px-4 py-2.5 font-sub text-[11px] uppercase tracking-[0.16em] font-bold rounded-sm hover:bg-[#0FCE68] disabled:opacity-50 transition-colors"
                        data-testid="newsletter-submit"
                    >
                        {loading ? "…" : "Subscribe"}
                    </button>
                </div>
            )}
            <div className="mt-1.5 font-sub text-[10px] uppercase tracking-[0.18em] text-black/35">
                Free · no spam · unsubscribe anytime
            </div>
        </form>
    );
}
